import { container, ICreatePreRegistrazione, Symbols } from "@dav/core";
import Toast from "@efesto-cloud/toast";
import { ActionFunctionArgs, Form, Link, MetaFunction, useActionData } from "react-router";
import useToaster from "~/components/Toaster/useToaster";
import z from "zod";



const action_validator = z.object({
    ragione_sociale: z.string().trim().min(1, 'La ragione sociale è obbligatoria'),
    email: z.string().trim().toLowerCase().email('Email non valida'),
    contatto_telefonico: z.string().optional(),
});
export const meta: MetaFunction = () => [{ title: 'Pre-registrazione Impresa' }];

export async function action(args: ActionFunctionArgs) {
    const body = action_validator.parse(Object.fromEntries(await args.request.formData()));

    const result = await container
        .get<ICreatePreRegistrazione>(Symbols.UseCase.pre_registrazione.CreatePreRegistrazione)
        .execute({
            ragione_sociale: body.ragione_sociale,
            email: body.email,
            contatto_telefonico: body.contatto_telefonico,
        });
    if (result.isSuccess()) {
        return Toast.fromResult(result, 'Pre-registrazione avvenuta con successo. Verrai avvertito via email per i prossimi passi.');
    }
    return Toast.fromResult(result, 'Errore durante la pre-registrazione');
}

export default function PreRegistrazione() {
    const actionData = useActionData<typeof action>();
    useToaster(actionData);

    return (
        <div className="hero bg-base-200 min-h-screen pt-safe">
            <img
                src="/icona-full.svg"
                alt=""
                className="absolute inset-0 h-full w-full object-cover object-center opacity-10 pointer-events-none"
            />
            <div className="hero-content flex-col lg:flex-row-reverse gap-16">
                <div className="text-center lg:text-left max-w-xl">
                    <h1 className="text-5xl font-bold text-base-content">Pre-registrazione Impresa</h1>
                    <p className="py-6 text-base-content/70 text-lg">
                        Richiedi l'accesso al Portale Imprese DAV. Compila il modulo con i tuoi dati
                        e riceverai un'email di conferma con i prossimi passi per completare la registrazione.
                    </p>
                    <p className="text-base-content/70 text-lg">
                        Hai già un account?{' '}
                        <Link to="/" className="link link-primary">
                            Accedi qui.
                        </Link>
                    </p>
                </div>

                <div className="card bg-base-100 w-full max-w-sm shrink-0 shadow-2xl">
                    <Form method="post" className="card-body space-y-2">
                        <h2 className="text-2xl font-semibold text-base-content">
                            Compila il modulo
                        </h2>

                        <label className="input input-bordered flex items-center gap-2">
                            <span className="text-sm">Ragione Sociale:</span>
                            <input
                                name="ragione_sociale"
                                type="text"
                                className="grow"
                                placeholder="es. Ditta Rossi S.r.l."
                                required
                            />
                        </label>

                        <label className="input input-bordered flex items-center gap-2">
                            <span className="text-sm">Email:</span>
                            <input
                                name="email"
                                type="email"
                                className="grow"
                                placeholder="esempio@impresa.it"
                                autoComplete="email"
                                required
                            />
                        </label>

                        <label className="input input-bordered flex items-center gap-2">
                            <span className="text-sm">Contatto Telefonico:</span>
                            <input
                                name="contatto_telefonico"
                                type="tel"
                                className="grow"
                                placeholder="+39 06 1234567"
                                autoComplete="tel"
                            />
                        </label>

                        <div className="form-control mt-4">
                            <button
                                type="submit"
                                className="btn btn-primary">
                                Invia Richiesta
                            </button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}
